const escape_html_map = {
    "&" : "&amp;",
    "<" : "&lt;",
    ">" : "&gt;",
    "\"": "&quot;",
    "'" : "&#39;",
    "/" : "&#x2F;",
    "`" : "&#x60;",
    "=" : "&#x3D;"
};
const escape_html = string => String(string).replace(/[&<>"'`=/]/g, s => escape_html_map[s]);

export {escape_html};
